/**
 * Close Dropdown On Click Outside
 */
const closeDropdownOnClickOutside = () => {
	$(document).on('click', function(event) {
		const $trigger = $('.dropdown.is-active');

		if (! $trigger.length) {
			return;
		}

		$trigger.each(function(index, el) {
			const $this = $(this);

			if($this !== event.target && ! $this.has(event.target).length) {
				$this.removeClass('is-active');
			}
		});
	});
}

closeDropdownOnClickOutside();
